import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import HeaderScreen from "../../screens/HeaderScreen/index";
import { menuRoutes } from "../../core/router/routes";
import { useDispatch, useSelector } from "react-redux";
import {
  setData as setDispatch,
  setLogout,
} from "../../core/redux/app/Actions";
import { sort } from "fast-sort";
import { loadCompaniesWithContracts } from "../../core/utils/company";

const HeaderContainer = () => {
  const navigate = useSelector((state) => state.app.navigate);
  const user = useSelector((state) => state.app.user || {});
  const company = useSelector(
    (state) => state.app.company || { id: -1, name: "Prospera" }
  );
  let history = useHistory();
  const route = menuRoutes(user, company).find(
    (item) => item.path === navigate
  );
  const courseName = useSelector((state) => state.app.courseName);
  const [data, setData] = useState([]);
  const reloadCompany = useSelector(
    (state) => state.app.reloadCompany || false
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (data && data.length > 0) {
      const ordenateData = sort(data).asc((u) => u.id);
      const newCompany = ordenateData[0];
      if (newCompany && newCompany.id && (!company || company?.id === -1)) {
        dispatch(setDispatch({ company: newCompany }));
      }
    }
  }, [data]);

  useEffect(() => {
    if (route && route.hideHeader) return;
    loadData();
  }, [reloadCompany, navigate]);

  const loadData = async () => {
    // Check if user is super admin
    const isSuperAdmin = !!user.isSuperAdmin;

    // Use optimized function with JOIN to avoid N+1 queries
    const companies = await loadCompaniesWithContracts({
      userId: user?.id,
      isSuperAdmin,
    });

    if (companies && companies.length > 0) {
      const ordenateData = sort(companies).asc((u) => u.id);
      setData(ordenateData);
    }
  };

  const onLogout = () => {
    supabase.auth.signOut();
    history.push("/");
    dispatch(setLogout({}));
  };

  const changeCompany = (company) => {
    // setSelected(company)
    if (company && company.id) {
      dispatch(setDispatch({ company })); //navigate: "/dashboard"
      // history.push("/dashboard");
    }
  };

  return (
    <HeaderScreen
      onLogout={onLogout}
      route={route}
      data={data}
      selected={company}
      changeCompany={changeCompany}
      history={history}
      courseName={courseName}
      user={user}
    />
  );
};

export default HeaderContainer;
